module.exports = __webpack_public_path__ + "static/media/2-2.177b25d7.mp3";